export enum ERolesName {
  /**
   * @member {string}
   * @Type User type administrator
   * @description user super administrator. has all permissions
   */
  SUPER_ADMIN = "Super Administrador",
  /**
   * @member {string}
   * @Type User type administrator
   * @description user administrator. user administrator about his agency
   */
  ADMIN = "Administrador",
  /**
   * @member {string}
   * @Type User type agent
   * @description user Broker. Account owner agency
   */
  BROKER = "Broker",
  /**
   * @member {string}
   * @Type User type agent
   * @description is  like user broker but have diferente name
   */
  BROKER_MANAGER = "Broker Manager",
  /**
   * @member {string}
   * @Type User type agent
   * @description user super senior.
   */
  SENIOR = "Asociado Senior",
  /**
   * @member {string}
   * @Type User type agent
   * @description user junior
   */
  JUNIOR = "Asociado Junior",
  /**
   * @member {number}
   * @Type User type Client
   * @description i dont know what is this
   */
  CLIENT = "Cliente"
}

export const CRolesName = {
  ...ERolesName
};

export type TRolesName = typeof ERolesName;
